import { useFlag } from '@unleash/proxy-client-react';

/**
 * PRD-1605: the Library page is open only when the nav item is shown (`library`)
 * AND unlocked (`library_page`). `library` alone keeps the PRD-1414 locked
 * placeholder. The route (App.js) and the nav item (Sidebar.jsx) both read this
 * hook, so they can never disagree. When the backend lands, its RBAC check
 * (`can_access_library`) belongs beside this one.
 */
export function useLibraryPageEnabled() {
  const libraryEnabled = useFlag('library');
  const libraryPageEnabled = useFlag('library_page');
  return libraryEnabled && libraryPageEnabled;
}
